import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataFood, setDataFood] = useState(false);
    
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);



      useEffect(() => {
              menus.map((item) => {
                  if (item.id === 435) {
                  setDataFood(item);
                  }
             
             
              });
      }, [menus]);
    
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
             setshowCategories(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);



    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showHome={false} showImageTop={true} setShowSpecials={setShowSpecials} goCategories={setshowCategories}>
            <div>
                <div style={{ width: '100%' }}>
                    <img
                        style={{
                            width: 300,
                            height: 120,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: -20,
                            
                        }}
                        src={require('./assets/66fff140c1b6b.jpg')}
                    />
                </div>
                <div style={{ display: 'flex', width: '100%',  position: 'relative', zIndex: 100, marginTop: 20, paddingInline: 20, boxSizing: 'border-box' }}>
                       
                   
                    <div style={{ width: '100%' }} >

                            <video
                                autoPlay
                                muted
                                loop
                            onClick={() => {
                                  // setshowCategories(true)
                                }}
                                style={{
                                    width: '100%',
                                    height: 350,
                                    objectFit: 'contain',
                                borderRadius: 14,
                                    
                                }}
                                src={require('./assets/promo.mp4')}
                            />
                            

                             <div
                                style={{
                                    display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                width: '100%',
                                }}>
                                <div
                                    
                                    onClick={()=>setshowCategories(true)}
                                    
                                    style={{
                                    marginTop: 10,
                                    width: '95%',
                                    backgroundColor: 'white',
                                    borderRadius: 13,
                                }}>
                                <img
                                    style={{
                                    width: '100%',
                                    height: 250,
                                    resizeMode: 'cover',
                                    borderRadius: 14,
                                    }}
                                    src={require('./assets/banner.png')}
                                />

                                <p
                                    style={{
                                    color: '#FF0000',
                                    fontWeight: 'bold',
                                    fontSize: 25,
                                    alignSelf: 'center',
                                    marginTop: 10,
                                    marginBottom: 10,
                                    }}>
                                    {langEng ? 'TAP HERE TO SEE MENU' : 'TAP AQUÍ PARA VER EL MENÚ'}
                                </p>
                                </div>
                            </div>
                    </div>
                </div>
               
            </div>


            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
            {showBar && <BarScreen setShowBar={setShowBar} />}
            </LayoutContent>
            </div>
    );
}

export default Index;